import React, { useContext } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Body1, Breakpoint, Link } from "@arcteryx/components-typography";
import { SiteContext } from "@arcteryx/components-contexts";
import { getTrackingUrl } from "./GetTrackingUrl";

// Keep these comments - used for i18next-parser
// t('NEW')
// t('CANCELLED')
// t('APPROVED')
// t('ORDER CONFIRMED')
// t('PARTIAL APPROVED')
// t('SHIPPED')
// t('ERROR PAYMENT')
// t('ORDER RECEIVED')
// t('ORDER REJECTED')

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px 0px;
  margin-bottom: 2em;
  border-bottom: 1px solid var(--pinline-grey);
  h2,
  h3 {
    width: 35%;
    ${Breakpoint("lg")`
    width: 35%;
  `}
    ${Breakpoint("xs")`
      width: 100%;
    `}
  }
  h4 {
    width: 21%;
    text-align: center;
    ${Breakpoint("xs")`
      display: none;
    `}
  }
`;

const StyledOrderHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${Breakpoint("lg")`
    flex-direction: row;
  `}
  ${Breakpoint("sm")`
    justify-content: inherit;
  `}
  ${Breakpoint("xs")`
    flex-direction: column;
  `}
`;
const StyledOrderDescription = styled.div`
  display: flex;
  ${Breakpoint("lg")`
    flex-direction: row;

    div {
      margin-right: 0.33rem;
    }
  `}
  ${Breakpoint("xs")`
    flex-direction: column;
  `}
`;
const StyledOrderStatus = styled.div`
  display: flex;
  ${Breakpoint("lg")`
    flex-direction: row;

    div {
      margin-right: 0.33rem;
    }
  `}
  ${Breakpoint("xs")`
    flex-direction: column;
  `}
`;
const StyledOrderSpan = styled.span`
  font-weight: 500;
`;
const StyledOrderSpanStatus = styled.span`
  color: var(--colour-black);
`;

const StyleTracking = styled.a`
  font-size: 1.1em;
  color: var(--colour-black);
  text-decoration: underline;
`;

const StyleTrackingSpan = styled.span`
  font-size: 1.1em;
  color: var(--colour-black);
`;

const OrderHeader = ({ orderNo, orderDate, status, trackingNumber, trackingUrl }) => {
  const { t } = useTranslation("components-order-history");
  const { country, language } = useContext(SiteContext);
  const lang = language === "jp" ? "ja" : language;

  const orderCreatedDate = new Date(orderDate);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const locale = `${lang}-${country?.toUpperCase()}`;
  const trackingUrlLink = getTrackingUrl({trackingUrl, trackingNumber});
  return (
    <>
      <StyledOrderDescription>
        <div>
          <Body1 tag="span">{t("Order Number")}: </Body1>
          <Body1 tag="span" className="qa-total-number" aria-label="Order Item Number">
            {orderNo}
          </Body1>
        </div>
        {orderDate && (
          <div>
            <Body1 tag="span">{t("Order Date")}: </Body1>
            <Body1 tag="span" className="qa-total-number" aria-label="Order Item Created Date">
              {orderCreatedDate.toLocaleDateString(locale, options).replace(/ /g, " ")}
            </Body1>
          </div>
        )}
      </StyledOrderDescription>
      <StyledOrderStatus className="status">
        <div>
          {" "}
          <Body1 tag="span"> {t("Status")}: </Body1>
          <Body1 tag="span" data-testid="status">{t(status)}</Body1>
        </div>
        <div>
          {trackingNumber && (
            <>
              <Body1 tag="span">{t("Tracking No")}:</Body1>
              {trackingUrlLink ? (
                <Link target="_blank" href={trackingUrlLink} rel="noreferrer ">
                  {trackingNumber}
                </Link>
              ) : (
                <StyleTrackingSpan> {trackingNumber}</StyleTrackingSpan>
              )}
            </>
          )}
        </div>
      </StyledOrderStatus>
    </>
  );
};

const OrderHistoryHeader = ({ order }) => (
  <Header>
    <StyledOrderHeader>
      <OrderHeader
        orderNo={order.orderNo}
        orderDate={order.orderDate}
        status={order.status}
        trackingNumber={
          Array.isArray(order.shipments) && order.shipments.length && order?.shipments[0]?.trackingNumber !== "NULL"
            ? order?.shipments[0]?.trackingNumber
            : order.trackingNumber
        }
        trackingUrl={
          Array.isArray(order.shipments) && order.shipments.length && order?.shipments[0]?.trackingUrl !== "NULL"
            ? order?.shipments[0]?.trackingUrl
            : order.trackingUrl
        }
      />
    </StyledOrderHeader>
  </Header>
);

export default OrderHistoryHeader;
